import React from 'react';
import IndividualTileBadge from './IndividualTileBadge';
import { getFriendlyNameFromProfessionalType, getTooltipAdviserType } from '../../data/attributeHelper';
import ShieldIcon from '../vectors/ShieldIcon';

const ProfessionalTypeIndividualTileBadge = ({ type, firstName }) => {
    const friendlyName = getFriendlyNameFromProfessionalType(type);

    return (
        <IndividualTileBadge
            label={friendlyName}
            icon={<ShieldIcon />}
            tooltip={getTooltipAdviserType(friendlyName, firstName)}
        />
    );
};

export default ProfessionalTypeIndividualTileBadge;
